var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "folder",
    enableBackground: "new 0 0 300 300",
    height: 512,
    viewBox: "0 0 300 300",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m131.516 78.484c.781.781 1.805 1.172 2.828 1.172s2.047-.391 2.828-1.172l2.828-2.828 2.828 2.828c.781.781 1.805 1.172 2.828 1.172s2.047-.391 2.828-1.172c1.562-1.562 1.562-4.094 0-5.656l-2.828-2.828 2.828-2.828c1.562-1.562 1.562-4.094 0-5.656s-4.094-1.562-5.656 0l-2.828 2.828-2.828-2.828c-1.562-1.562-4.094-1.562-5.656 0s-1.562 4.094 0 5.656l2.828 2.828-2.828 2.828c-1.563 1.563-1.563 4.094 0 5.656z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 184,
    cy: 86,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 172,
    cy: 42,
    r: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "m240 102h-114.345l-7.783-16.145c-.105-.219-.23-.428-.373-.623-3.422-4.686-8.971-7.482-14.842-7.482h-44.569c-9.975 0-18.088 7.973-18.088 17.773v135.855c0 9.446 7.224 17.187 16.514 18.379 1.721 7.065 8.086 12.243 15.486 12.243h160c7.882 0 14.411-5.741 15.722-13.254 7.155-2.665 12.278-9.417 12.278-17.367v-109.379c0-11.027-8.973-20-20-20zm12 129.379c0 5.857-4.914 10.621-10.955 10.621h-140.285c-2.209 0-4 1.791-4 4s1.791 4 4 4h138.128c-1.387 2.38-3.939 4-6.887 4h-160.001c-2.912 0-5.511-1.602-6.911-4h15.013c2.209 0 4-1.791 4-4s-1.791-4-4-4h-21.147c-6.041 0-10.955-4.764-10.955-10.621v-135.856c0-5.389 4.525-9.773 10.088-9.773h44.568c3.213 0 6.246 1.465 8.18 3.936l5.937 12.314h-20.773c-2.209 0-4 1.791-4 4s1.791 4 4 4h144c6.617 0 12 5.383 12 12z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyFolder);
export default __webpack_public_path__ + "static/media/empty-folder.bb697383f2730baeba0940da222ba75e.svg";
export { ForwardRef as ReactComponent };